<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>

            <span class="child">/ Proctor Duty Appointment</span>
        </v-row><br />
        <v-card>
            <v-card-title class="justify-center heading">
                <h4>Proctor Duty Appointment</h4>
            </v-card-title>
            <v-overlay :value="loader" absolute>
                Loading
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-form ref="form">
                <div class="box">
                    <v-row>
                        <v-col xs="12" sm="12" lg="3" md="6" cols="12">
                            <label class="bold">Exam</label>
                            <v-autocomplete :items="exam_list" item-value="id" item-text="exam" v-model="exam"
                                @change="findDates()" :rules="[v => !!v || 'required']" outlined dense
                                placeholder="Select Exam" class="select"></v-autocomplete>
                        </v-col>
                        <!-- <v-col xs="12" sm="12" lg="3" md="6" cols="12">
                            <label class="bold" style="margin-left: 2rem;">Exam Date </label>
                            <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field class="date" dense outlined v-model="date" prepend-icon="event" readonly v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="date" no-title scrollable :date-format="date => new Date(date).toDateString()">
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col> -->
                        <v-col xs="12" sm="12" lg="3" md="6" cols="12">
                            <label class="bold">Exam Date</label>
                            <v-select :items="dates" outlined dense placeholder="Select Exam Date" @change="findSlot()"
                                v-model="date" :rules="[v => !!v || 'required']" class="select"></v-select>
                        </v-col>
                        <v-col xs="12" sm="12" lg="2" md="6" cols="12">
                            <label class="bold">Slot No </label>
                            <v-select :items="slot_list" item-value="id" item-text="slotNo" outlined dense
                                @change="findtime()" placeholder="Select Slot" v-model="slotNo"
                                :rules="[v => !!v || 'required']" class="select"></v-select>
                        </v-col>
                        <v-col xs="12" sm="12" lg="2" md="6" cols="12">
                            <label class="bold">Start Time </label>
                            <v-text-field readonly v-model="startTime" outlined dense class="select"></v-text-field>
                        </v-col>
                        <v-col xs="12" sm="12" lg="2" md="6" cols="12">
                            <label class="bold">End Time</label>
                            <v-text-field readonly v-model="endTime" outlined dense class="select"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-card-actions class="justify-center">
                        <v-btn class="mb-2 button btn" @click="fetchdetails()">Fetch</v-btn>
                    </v-card-actions>
                </div>
                <!-- <div v-if="!check"> -->
                <div>
                    <v-row class="justify-center" v-if="addProctor">
                        <span> <strong>Student Count :</strong> <strong
                                style="color:green">{{studCount}}</strong></span>
                        <span class="pl-4"> <strong>Proctor required :</strong> <strong
                                style="color:green">{{proctorCount}}</strong></span>
                    </v-row>
                    <v-row class="justify-center" v-if="addProctor">
                        <span>{ Proctor student ratio: <strong style="color:green">1:{{proctor_limit}}</strong> }</span>
                    </v-row>
                    <div class="box-import" v-if="addProctor">
                        <v-row>
                            <v-col cols="3">
                                <v-file-input dense accept=".csv" v-model="file"
                                    :hint="file != null? '':'Please Select File'" persistent-hint
                                    color="rgb(1, 127, 152)" label="Choose File" prepend-icon="mdi-paperclip" outlined
                                    :show-size="1000"> </v-file-input>

                            </v-col>
                            <v-col cols="2">
                                <v-btn @click="submitFile" :loading="output_load" class="button">
                                    Upload
                                    <v-icon right>mdi-cloud-upload</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="7" align="right">
                                <a style="text-decoration: none;"
                                    href="https://easypariksha.s3.ap-south-1.amazonaws.com/import_excel_csv_file/appointProctor.csv">
                                    <v-btn :loading="loading3" :disabled="loading3" color="success"
                                        class="ma-2 white--text downbtn " @click="loader = 'loading3'">
                                        <v-icon left dark>mdi-cloud-download</v-icon>
                                        Download import CSV format
                                    </v-btn>
                                </a>
                            </v-col>

                        </v-row>
                        <center>
                            <v-col v-if="allData.length > 0">
                                <v-simple-table class="elevation-1 mytable">
                                    <thead>
                                        <tr style="background-color:hsla">
                                            <th class="text-left">Employee Code</th>
                                            <th class="text-left">Fail Reason</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item) in allData" :key="item">
                                            <td style="color:red">{{ item.proctor }}</td>
                                            <td style="color:red">{{ item.msg }}</td>
                                        </tr>
                                    </tbody>
                                </v-simple-table></v-col>
                        </center>
                    </div>


                    <v-row class="justify-center" v-if="addProctor">
                        <v-col cols="12" sm="6" md="6" lg="6">
                            <div class="a-proctor">
                                <center><strong>Appoint Proctor</strong></center>
                                <v-row class="justify-center">
                                    <v-col cols="12" sm="6" lg="6" md="6">
                                        <v-autocomplete :items="instructor_list" v-model="proctor" item-value="ins_id"
                                            item-text="ins_emp_code_name" dense placeholder="Select Instructor"
                                            outlined />
                                    </v-col>
                                    <v-col cols="12" sm="3" lg="3" md="3">
                                        <v-btn class="mb-2 button btn" @click="addProctorData">Add</v-btn>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row class="justify-center" v-if="addProctor">
                        <v-col cols="12">
                            <template v-if="addProctor">
                                <!-- {{proctor_list}} -->
                                <div class="flex-right">
                                    <div>
                                        <download-excel :data="proctor_list" worksheet="proctor_list"
                                            :fields="exam_proctor_list" name="Exam_proctor_list.xls">
                                            <v-btn color="success" class="ma-2 white--text downbtn">
                                                <v-icon left dark>mdi-file-excel</v-icon>
                                                export xls
                                            </v-btn>
                                        </download-excel>
                                    </div>
                                </div>






                                <v-data-table :headers="headers1" :items="proctor_list" :item-value="proctor_id" sort-by
                                    class="elevation-1 mytable" :search="search" :loading="output_load">
                                    <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                        hide-details></v-text-field>
                                    <template v-slot:item.delete="{ item }">
                                        <span v-if="item.flag == 'false'">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon color="gray" v-bind="attrs"
                                                        v-on="on">mdi-delete-circle</v-icon>
                                                </template>
                                                <span>
                                                    This Proctor Is Assigned Can't Delete!!!
                                                </span>
                                            </v-tooltip>
                                        </span>
                                        <span v-else>
                                            <v-icon color="red" class="mr-2"
                                                @click="deletedialog(item)">mdi-delete-circle</v-icon>
                                        </span>
                                    </template>
                                </v-data-table>
                            </template>
                        </v-col>
                    </v-row>
                </div>
                <p class="table-name">ALL PROCTOR APPOINTMENT DUTY SUMMARY</p>

                <v-data-table :headers="headers2" :search="search1" :items="arr" :item-value="id" sort-by
                    class="elevation-1 mytable" :loading="output_load">
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-text-field v-model="search1" label="Search" class="pt-4"></v-text-field>
                            <v-spacer></v-spacer>

                            <div class="flex-right">
                                <div>
                                    <download-excel :data="arr" worksheet="arr" :fields="all_exam_proctor_list"
                                        name="all_exam_proctor_list.xls">
                                        <v-btn color="success" class="ma-2 white--text downbtn">
                                            <v-icon left dark>mdi-file-excel</v-icon>
                                            export xls
                                        </v-btn>
                                    </download-excel>
                                </div>
                            </div>
                        </v-toolbar>
                    </template>


                    <v-text-field v-model="search" append-icon="search" label="Search" single-line
                        hide-details></v-text-field>
                    <template v-slot:item.proctor="{ item }">
                        <span @click="proctorList(item)"
                            style="cursor: pointer; text-decoration: underline;"><a>{{item.examdata.proctor_count}}</a></span>
                    </template>
                </v-data-table>
                <!-- </div> -->
            </v-form>
        </v-card>
        <v-dialog v-model="proclist" scrollable max-width="600px">
            <v-card>
                <v-card-title class="heading">Proctor Details</v-card-title>
                <v-simple-table>
                    <thead>
                        <tr>
                            <th class="text-left">Sr no</th>
                            <th class="text-left">Proctor Code</th>
                            <th class="text-left">Proctor Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in proctordata" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td>{{ item.code }}</td>
                            <td>{{ item.name }}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
                <v-card-actions class="justify-center" style="background: white;">
                    <v-btn class="button" text @click="proclist = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_delete" persistent max-width="500px">
            <v-card class="delete-popup">
                <v-container>
                    <input type="hidden" v-model="deleteItem.delete_id" />
                    <p>Are you sure you want Delete this Question???</p>
                    <v-row justify="center">
                        <v-btn class="button-cancel mr-2" @click="dialog_delete = false">No</v-btn>
                        <v-btn class="button" @click="deleteProctor()">Yes</v-btn>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
        <br />
        <router-view />
    </div>
</template>
<script>
    import "@/assets/css/color.css";
    import moment from "moment";

    import axios from "axios";
    export default {
        data() {
            return {
                file: null,
                studCount: '',
                proctorCount: '',
                proctor_limit: '',
                loader: false,
                dates: [],
                arr: [],
                output_load: false,
                exam: "",
                proctor: "",
                sessionNo: "",
                date: "",
                // date: new Date().toISOString().substr(0, 10),
                menu: false,
                examDate: "",
                snackbar_msg: "",
                proctordata: [],
                snackbar: false,
                color: "",
                addProctor: false,
                slotNo: "",
                startTime: "",
                endTime: "",
                search: "",
                search1: "",
                proclist: false,
                exam_list: [],
                slot_list: [],
                exam_proctor_session_list: [],
                instructor_list: [],
                proctor_list: [],
                deleteItem: {
                    delete_id: "",
                },
                allData: [],
                id: "",
                dialog_delete: false,
                check: "",
                exam_proctor_list: {
                    "Sr. No.": "srno",
                    Exam: "examname",
                    "Proctor Code": "proctor_code",
                    "Proctor Name": "proctor_name",
                },
                all_exam_proctor_list: {
                    "Sr. No.": "examdata.srno",
                    Exam: "examdata.exam",
                    "Exam Date": "examdata.eaxmdate",
                    Slot: "examdata.examslot",
                    "Start Time": "examdata.starttime",
                    "End Time": "examdata.endtime",
                    "Proctor Count": "examdata.proctor_count",
                },
                headers1: [
                    { text: "Sr No", value: "srno" },
                    { text: "Proctor Code", value: "proctor_code" },
                    { text: "Proctor Name", value: "proctor_name" },
                    { text: "Action", value: "delete" },
                ],
                headers2: [
                    { text: "Sr No", value: "examdata.srno" },
                    { text: "Exam", value: "examdata.exam" },
                    { text: "Exam Date", value: "examdata.eaxmdate" },
                    { text: "Slot No.", value: "examdata.examslot" },
                    { text: "Start Time", value: "examdata.starttime" },
                    { text: "End Time", value: "examdata.endtime" },
                    { text: "Proctor", value: "proctor" },
                ],
            };
        },
        mounted() {
            this.onLoad();
        },
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            submitFile() {
                this.output_load = true
                if (this.file == null) {
                    this.showSnackbar("#b71c1c", "Please select the file!");
                    this.output_load = false

                    //alert("Please select the file!");
                } else {
                    let formatDate = moment(this.date, "DD-MM-YYYY").format("YYYY-MM-DD");

                    this.output_load = true;
                    let formData = new FormData();
                    formData.append("file", this.file);
                    formData.append("slot", this.slotNo);
                    formData.append("exam", this.exam);
                    formData.append("date", formatDate);
                    formData.append("proctor", this.proctor);
                    this.dialog_send = true
                    axios
                        .post("/ProctorDutyAppoinment/addProctorImport", formData, {
                            headers: {
                                "Content-Type": "multipart/form-data"
                            }
                        })
                        .then(res => {
                            if (res.data.msg == "200") {
                                this.allData = res.data.allData
                                this.fetchdetails();
                                this.output_load = false
                                this.file = null
                            } else {
                                this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            }
                        })
                        .catch(function () {
                            console.log("FAILURE!!");
                        })
                        .finally(() => {
                            this.output_load = false;
                            this.output_load = false
                        });
                    //     }
                }
            },
            onLoad() {
                this.loader = true;
                axios
                    .post("/ProctorDutyAppoinment/getproctorappointmentdeatilsnew")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.exam_list = res.data.exam_list;
                            // this.slot_list = res.data.slot_list;
                            this.exam_proctor_session_list = res.data.exam_proctor_session_list;

                            this.arr = res.data.exam_proctor_session_list;
                            // for (let i = 0; i < this.arr.length; i++) {
                            //     for (let j = 0; j < this.arr.length; j++) {
                            //         if (i !== j) {
                            //             if (this.arr[i]) {
                            //                 let abc = this.arr[i].examdata.examslot == this.arr[j].examdata.examslot;
                            //                 let exam = this.arr[i].examdata.exam == this.arr[j].examdata.exam;
                            //                 let date = this.arr[i].examdata.eaxmdate == this.arr[j].examdata.eaxmdate;
                            //                 if (abc && exam && date) {
                            //                     this.arr.splice(j, 1);
                            //                 }
                            //             }
                            //         }
                            //     }
                            // }
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            // alert("in else");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        console.log("error", error);
                    })
                    .finally(() => {
                        this.loader = false;
                    });
            },
            findSlot() {
                let formatDate = moment(this.date, "DD-MM-YYYY").format("YYYY-MM-DD");

                const data = {
                    examId: this.exam,
                    date: formatDate,
                };
                axios
                    .post("/ProctorDutyAppoinment/getSlot", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.slot_list = res.data.slot;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        // alert("in catch")
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => { });
            },

            findDates() {
                const data = {
                    examId: this.exam,
                };
                axios
                    .post("/ProctorDutyAppoinment/getExamDate", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.dates = res.data.dates;
                        } else {
                            //  alert("in else")
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        //  alert("in catch")
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => { });
            },
            findtime() {
                const data = {
                    slot: this.slotNo,
                };
                axios
                    .post("/ProctorDutyAppoinment/getslottime", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.endTime = res.data.end_time;
                            this.startTime = res.data.start_time;
                        } else {
                            // alert("in else")
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        // alert("in catch")
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => { });
            },
            proctorList(item) {
                this.proclist = true;
                console.log("item", item.examdata);
                axios
                    .post("/ProctorDutyAppoinment/proctorData", item.examdata)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.proctordata = res.data.proctordata;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => { });
            },
            addProctorData() {
                let formatDate = moment(this.date, "DD-MM-YYYY").format("YYYY-MM-DD");
                if (this.proctor == "") {
                    this.showSnackbar("#b71c1c", "Please Select Proctor/Instructor.!!!");
                    return;
                }
                const data = {
                    slot: this.slotNo,
                    exam: this.exam,
                    date: formatDate,
                    proctor: this.proctor,
                };
                axios
                    .post("/ProctorDutyAppoinment/addProctor", data)
                    .then((res) => {
                        if (res.data.status.code == "SUCCESS") {
                            this.showSnackbar("success", "Proctor added successfully");
                            this.fetchdetails();
                            this.onLoad();
                            this.proctor = "";
                        }
                        if (res.data.status.code == "NA") {
                            this.showSnackbar("error", "Proctor Alredy Exist!!");
                            this.proctor = "";
                        }
                    })
                    .catch((error) => {
                        console.log("error", error);
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => { });
            },
            deletedialog(item) {
                //alert(item)
                this.dialog_delete = true;
                this.deleteItem.delete_id = item;
            },
            deleteProctor() {
                //console.log('item',item);
                const data = {
                    // slot : this.slotNo,
                    //  exam : this.exam,
                    //  date :this.date,
                    proctor: this.deleteItem.delete_id,
                };
                axios
                    .post("/ProctorDutyAppoinment/deleteProctor", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("success", "Proctor deleted successfully");
                            this.dialog_delete = false;
                            this.fetchdetails();
                            this.onLoad();
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => { });
            },
            fetchdetails() {
                // this.allData = []
                let newDate = moment(this.date, "DD-MM-YYYY").format("YYYY-MM-DD");
                if (this.exam == "") {
                    this.showSnackbar("#b71c1c", "Please Select Exam.!!!");
                    return;
                }
                if (this.slotNo == "") {
                    this.showSnackbar("#b71c1c", "Please Select Slot No.!!!");
                    return;
                }
                const data = {
                    slot: this.slotNo,
                    exam: this.exam,
                    date: newDate,
                };
                axios
                    .post("/ProctorDutyAppoinment/fetchproctorappoinmentdetails", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.addProctor = true;
                            this.instructor_list = res.data.instructor_list;
                            this.proctor_list = res.data.proctor_list;
                            //  alert("in if")
                            this.studCount = res.data.stud_count;
                            this.proctorCount = res.data.proctor_count_set
                            this.proctor_limit = res.data.proctor_limit
                            this.check = res.data.exam_msg;
                            if (this.check) {
                                this.showSnackbar("#b71c1c", this.check);
                            }
                        } else {
                            // alert("in else")
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        // alert("in catch")
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => { });
            },
        },
    };
</script>
<style scoped>
    .table-name {
        color: hsla(190, 99%, 30%, 1);
        font-weight: bold;
        text-align: center;
    }

    .delete-popup {
        text-align: center;
        border: 4px solid red;
        /* margin: 1rem; */
        padding: 1rem;
        border-radius: 15px;
    }

    .flex {
        display: flex;
        justify-content: center;
        margin: 0px;
    }

    .flex-right {
        display: flex;
        justify-content: flex-end;
    }

    .box {
        background-color: #add8e630;
        margin: 8px;
        padding: 8px;
    }

    .select>>>.v-input__slot {
        background: white !important;
        border-color: hsla(190, 99%, 30%, 1) !important;
    }

    .date>>>.v-input__slot {
        background: white !important;
        border-color: hsla(190, 99%, 30%, 1) !important;
    }

    .a-proctor {
        border: 3px solid hsla(190, 99%, 30%, 1);
        border-radius: 15px;
    }

    .mytable /deep/ thead th {
        background-color: hsla(190, 99%, 30%, 1) !important;
        color: white !important;
        white-space: nowrap !important;
    }

    .box-import {
        border: 2px solid hsla(190, 99%, 30%, 1);
        margin: 1rem;
        padding: 1.1rem;
    }
</style>